module.exports = __webpack_public_path__ + "media/react/components/Exception/404-8a4510fe43403eb403dc0f627e9c7cec.svg";